/* TAMA - Barre de filtres/tri en pilules (page collection) - enrichit le filtre natif Shopify. Brouillon uniquement. */
(function(){
  var body=document.body;
  if(!body || body.className.indexOf('template-collection')<0) return;
  /* 18/10/2026 (Jerome) : sur MOBILE la cliente choisit 1 ou 2 pieces par ligne (boutons dans la barre Filtrer/Trier).
     Choix memorise sur l'appareil (localStorage tama_cols). Par defaut : 2. Sans effet sur ordinateur. */
  var COLS_KEY='tama_cols', cols=2;
  try{ if(localStorage.getItem(COLS_KEY)==='1') cols=1; }catch(e){}
  if(cols===1) body.classList.add('tama-cols-1');
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  ready(function(){
    var grid=document.querySelector('.grid-uniform');

    /* --- Tuiles editoriales "reel de Julie" : une tuile pleine largeur toutes les 12 pieces (8 sur mobile, 18/10/2026), video autoplay muette --- */
    var EVERY=(window.innerWidth<750)?8:12, usedHandles={};
    function money(c){ try{ if(window.Shopify && Shopify.formatMoney && typeof moneyFormat!=='undefined') return Shopify.formatMoney(c, moneyFormat); }catch(e){} return (Math.round(c)/100).toFixed(2).replace('.',',')+' €'; }
    function handleOf(card){ var a=card.querySelector('a[href*="/products/"]'); var m=a?(a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/):null; return m?m[1]:null; }
    function bestMp4(sources){ var mp4=(sources||[]).filter(function(s){return s.format==='mp4';}); if(!mp4.length) return null; mp4.sort(function(a,b){return Math.abs((a.width||0)-480)-Math.abs((b.width||0)-480);}); return mp4[0].url; }
    function imgUrl(u,w){ return u?u+(u.indexOf('?')>-1?'&':'?')+'width='+w:u; }
    /* 30/09/2026 : iPhone en MODE ECONOMIE D'ENERGIE (ou reglage « lecture auto » coupe) = iOS bloque la lecture automatique des videos.
       Avant : la tuile restait figee sur la vignette generique « video de presentation ». Maintenant : la vignette = la PHOTO de la piece,
       + un bouton lecture ; le 1er toucher sur la video la lance (un geste de la cliente est toujours autorise par iOS). */
    function tamaBlocked(v){ var m=v.closest&&v.closest('.tama-edit__media'); if(!m||m.classList.contains('is-tap')) return; m.classList.add('is-tap');
      var pb=document.createElement('span'); pb.className='tama-edit__play'; pb.setAttribute('aria-hidden','true'); pb.innerHTML='<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>'; m.appendChild(pb); }
    function tamaTry(v){ var p=v.play(); if(p&&p.catch){ p.then(function(){ var m=v.closest&&v.closest('.tama-edit__media'); if(m){ m.classList.remove('is-tap'); var pb=m.querySelector('.tama-edit__play'); if(pb) pb.remove(); } }).catch(function(){ tamaBlocked(v); }); } }
    (function(){ if(document.getElementById('tama-edit-fix-css')) return; var st=document.createElement('style'); st.id='tama-edit-fix-css';
      st.textContent='.tama-edit__play{position:absolute;left:50%;top:50%;z-index:5;width:64px;height:64px;margin:-32px 0 0 -32px;border-radius:50%;background:rgba(25,20,24,.62);display:flex;align-items:center;justify-content:center;pointer-events:none;box-shadow:0 6px 20px rgba(0,0,0,.25)}'+
        '.tama-edit__play svg{width:28px;height:28px;fill:#fff;margin-left:4px}'+
        '.tama-edit__body{min-width:0}html body .tama-edit__title,html body .tama-edit__title a{overflow-wrap:break-word;word-break:normal;hyphens:auto;-webkit-hyphens:auto;max-width:100%}';
      document.head.appendChild(st); })();
    document.addEventListener('click',function(e){ var m=e.target.closest&&e.target.closest('.tama-edit__media.is-tap'); if(!m||e.target.closest('.tama-edit__sound')) return; var v=m.querySelector('video'); if(v&&v.paused){ e.preventDefault(); tamaTry(v); } },true);
    var io2=('IntersectionObserver' in window)?new IntersectionObserver(function(es){ es.forEach(function(en){ var v=en.target; if(en.isIntersecting){ tamaTry(v); } else { v.pause(); } }); },{threshold:.35}):null;
    function openDrawer(){ var mc=document.querySelector('mini-cart'); if(mc && typeof mc.getItems==='function'){ mc.getItems(); if(typeof mc.openModal==='function') mc.openModal(); } else { location.href='/cart'; } }
    function addVariant(id, btn){ if(!id||btn.classList.contains('is-loading')) return; btn.classList.add('is-loading'); var lbl=btn.textContent; btn.textContent='Ajout…';
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'xmlhttprequest'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(){ btn.classList.remove('is-loading'); btn.textContent='Ajouté ✓'; setTimeout(function(){ btn.textContent=lbl; },1600); openDrawer(); })
      .catch(function(){ btn.classList.remove('is-loading'); btn.textContent=lbl; location.href='/cart'; }); }
    function buildTile(prod, handle, vurl, poster){
      var url='/products/'+handle;
      var li=document.createElement('div'); li.className='grid-item tama-edit';
      var inner=document.createElement('div'); inner.className='tama-edit__inner';
      var media=document.createElement('a'); media.className='tama-edit__media'; media.href=url;
      var vid=document.createElement('video'); vid.muted=true; vid.loop=true; vid.playsInline=true; vid.setAttribute('playsinline',''); vid.setAttribute('muted',''); vid.preload='metadata'; if(poster) vid.poster=poster;
      var so=document.createElement('source'); so.src=vurl; so.type='video/mp4'; vid.appendChild(so); media.appendChild(vid);
      var badge=document.createElement('span'); badge.className='tama-edit__badge'; badge.textContent='Filmée par Julie'; media.appendChild(badge);
      var body=document.createElement('div'); body.className='tama-edit__body';
      var eb=document.createElement('div'); eb.className='tama-edit__eyebrow'; eb.textContent='Vue en vidéo';
      var h=document.createElement('h3'); h.className='tama-edit__title'; var hl=document.createElement('a'); hl.href=url; hl.textContent=prod.title||''; h.appendChild(hl);
      var pr=document.createElement('div'); pr.className='tama-edit__price'; pr.textContent=money(prod.price);
      body.appendChild(eb); body.appendChild(h); body.appendChild(pr);
      /* description courte (ordinateur uniquement via CSS) */
      var dtxt=(prod.description||'').replace(/<[^>]+>/g,' ').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim();
      if(dtxt){ var d=document.createElement('p'); d.className='tama-edit__desc'; d.textContent=dtxt.length>220?dtxt.slice(0,217).replace(/\s+\S*$/,'')+'…':dtxt; body.appendChild(d); }
      /* mise au panier rapide : un clic sur la taille = ajout direct au panier (bouton seulement si pas de variante) */
      var vars=(prod.variants||[]); var single=vars.length===1 && (vars[0].title==='Default Title'||!vars[0].title);
      var anyOk=vars.some(function(v){return v.available;});
      var acts=document.createElement('div'); acts.className='tama-edit__acts';
      if(!single && vars.length){
        var lab=document.createElement('div'); lab.className='tama-edit__lab'; lab.textContent=anyOk?'Ta taille → direct au panier':'Épuisé';
        var sizes=document.createElement('div'); sizes.className='tama-edit__sizes';
        vars.forEach(function(v){ var b=document.createElement('button'); b.type='button'; b.className='tama-edit__size'+(v.available?'':' is-oos'); b.textContent=v.title; if(!v.available) b.disabled=true;
          b.addEventListener('click',function(){ [].forEach.call(sizes.children,function(c){c.classList.remove('is-on');}); b.classList.add('is-on'); addVariant(v.id, b); });
          sizes.appendChild(b); });
        body.appendChild(lab); body.appendChild(sizes);
      } else {
        var add=document.createElement('button'); add.type='button'; add.className='tama-edit__add'; add.textContent=anyOk?'Ajouter au panier':'Épuisé'; if(!anyOk) add.disabled=true;
        add.addEventListener('click',function(){ addVariant(vars[0]&&vars[0].id, add); });
        acts.appendChild(add);
      }
      var cta=document.createElement('a'); cta.className='tama-edit__cta'; cta.href=url; cta.innerHTML='Voir la pièce <svg viewBox="0 0 24 24"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
      acts.appendChild(cta); body.appendChild(acts);
      inner.appendChild(media); inner.appendChild(body); li.appendChild(inner);
      if(io2) io2.observe(vid); else tamaTry(vid);
      return li;
    }
    function productCards(){ return grid?[].filter.call(grid.children,function(c){ return c.classList && c.classList.contains('grid-item') && !c.classList.contains('tama-edit'); }):[]; }
    function placeEditorialTiles(){
      if(!grid) return;
      var cards=productCards();
      for(var i=EVERY-1;i<cards.length;i+=EVERY){
        var anchor=cards[i];
        if(anchor.getAttribute('data-tama-edit')) continue;
        anchor.setAttribute('data-tama-edit','1');
        (function(anchor,i){
          var cands=[]; for(var k=i+1;k<Math.min(cards.length,i+1+EVERY);k++){ var h=handleOf(cards[k]); if(h && !usedHandles[h]) cands.push(h); }
          if(!cands.length) return;
          var tried=0;
          function tryNext(){
            if(tried>=cands.length) return;
            var h=cands[tried++]; if(usedHandles[h]){ tryNext(); return; }
            usedHandles[h]=true; /* reserve */
            fetch('/products/'+h+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(prod){
              var vm=(prod.media||[]).filter(function(m){return m.media_type==='video'&&m.sources;})[0];
              var vurl=vm?bestMp4(vm.sources):null;
              if(!vurl){ delete usedHandles[h]; tryNext(); return; }
              if(!prod.available){ tryNext(); return; } /* 04/10/2026 : pas de video pour une piece epuisee */
              /* 30/09/2026 : vignette = photo de la piece (et non la vignette generique de la video) */
              var ph=prod.featured_image||(prod.images&&prod.images[0])||'';
              if(ph&&ph.indexOf('//')===0) ph='https:'+ph;
              var poster=ph?imgUrl(ph,600):((vm.preview_image&&vm.preview_image.src)?imgUrl(vm.preview_image.src,600):'');
              var tile=buildTile(prod,h,vurl,poster);
              if(anchor.parentNode===grid) grid.insertBefore(tile, anchor.nextSibling);
            }).catch(function(){ delete usedHandles[h]; tryNext(); });
          }
          tryNext();
        })(anchor,i);
      }
    }
    /* --- Badge « Cette semaine » sur les pieces du dernier drop (liste injectee en Liquid) --- */
    var FRESH={}, nFresh=0;
    (function(){ var L=window.TAMA_FRESH; if(Array.isArray(L)) L.forEach(function(h){ if(h){FRESH[h]=1;nFresh++;} }); })();
    function markFresh(){
      if(!nFresh||!grid) return;
      [].forEach.call(grid.querySelectorAll('.product-grid-item:not([data-tama-fresh])'),function(card){
        card.setAttribute('data-tama-fresh','1');
        var a=card.querySelector('a[href*="/products/"]');
        var m=a?(a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/):null;
        if(!m||!FRESH[m[1]]) return;
        var b=document.createElement('span'); b.className='tama-fresh-badge'; b.textContent='Cette semaine';
        card.appendChild(b);
      });
    }
    markFresh();

    placeEditorialTiles();

    /* --- "Voir plus" : charge les pieces suivantes SANS quitter la page (scroll conserve, filtres/tri conserves) --- */
    (function(){
      var pag=document.querySelector('ul.pagination-custom');
      if(!pag || document.querySelector('.tama-pgn')) return;
      var next=pag.querySelector('a[rel="next"]');
      if(!next) return; /* derniere page : rien a ajouter */
      if(!grid) return;
      var total=(typeof window.TAMA_COLL_COUNT==='number')?window.TAMA_COLL_COUNT:null;
      function shown(){ return grid.querySelectorAll('.product-grid-item').length; }

      var wrap=document.createElement('div'); wrap.className='tama-pgn';
      var a=document.createElement('a'); a.className='tama-pgn__btn'; a.href=next.getAttribute('href');
      a.innerHTML='<span>Voir plus</span><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12l7 7 7-7"/></svg>';
      var info=document.createElement('div'); info.className='tama-pgn__info';
      function paintInfo(){ info.textContent = (total!=null) ? (shown()+' sur '+total+' affichées') : ''; }
      paintInfo();
      wrap.appendChild(a); wrap.appendChild(info);
      pag.parentNode.insertBefore(wrap, pag);
      pag.style.display='none'; /* les numeros de page ne servent plus avec "Voir plus" (restent dans le HTML pour le SEO / sans JS) */

      var busy=false;
      function reveal(node){
        var els=[node].concat([].slice.call(node.querySelectorAll('.wow')));
        els.forEach(function(el){ if(el.classList) el.classList.remove('wow'); el.style.visibility='visible'; el.style.opacity='1'; el.style.animation='none'; });
      }
      a.addEventListener('click',function(e){
        e.preventDefault();
        if(busy) return; busy=true;
        var url=a.getAttribute('href');
        a.classList.add('is-loading'); a.querySelector('span').textContent='Chargement…';
        fetch(url,{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var src=doc.querySelector('.grid-uniform');
          var cards=src?[].filter.call(src.children,function(c){ return c.classList && c.classList.contains('grid-item'); }):[];
          if(!cards.length && src) cards=[].slice.call(src.querySelectorAll('.grid-item'));
          cards.forEach(function(c){ var n=document.importNode(c,true); reveal(n); grid.appendChild(n); });
          var nn=doc.querySelector('ul.pagination-custom a[rel="next"]');
          paintInfo();
          placeEditorialTiles();
          markFresh();
          if(nn){ a.setAttribute('href', nn.getAttribute('href')); a.querySelector('span').textContent='Voir plus'; }
          else { a.remove(); info.textContent = (total!=null) ? ('Tu as tout vu — '+shown()+' pièces') : 'Tu as tout vu'; }
          a.classList.remove('is-loading'); busy=false;
        }).catch(function(){ busy=false; location.href=url; });
      });
    })();

    var srcForm=document.querySelector('aside.collection-filters form.filter-form');
    var toggle=document.querySelector('.toggle-filters');
    var quarter=toggle?toggle.closest('.grid-item'):null;
    var gu=document.querySelector('.grid-uniform');
    var productsCol=gu?(gu.closest('.grid-item')||gu):null;
    if(!productsCol) return;
    if(document.querySelector('.tama-cf')) return; /* pas de doublon */

    var SEP='\u0001';

    /* --- lire les facettes natives --- */
    var groups=[];
    if(srcForm){
      srcForm.querySelectorAll('.filter-group').forEach(function(det){
        var sum=det.querySelector('summary,legend');
        var label=sum?sum.textContent.replace(/\s+/g,' ').trim():'Filtre';
        label=label.replace(/\s*\(\d+\)\s*$/,''); /* retire le compteur natif "(1)" ajouté quand un filtre est actif */
        var values=[];
        det.querySelectorAll('input[type=checkbox]').forEach(function(inp){
          if(!inp.name) return;
          var lab=inp.closest('label');
          var raw=lab?lab.textContent.replace(/\s+/g,' ').trim():inp.value;
          var m=raw.match(/^(.*?)\s*\((\d+)\)\s*$/);
          values.push({name:inp.name, value:inp.value, disp:(m?m[1]:raw)||inp.value, count:m?m[2]:''});
        });
        if(values.length) groups.push({label:label, values:values});
      });
    }

    /* --- état courant depuis l'URL --- */
    var params=new URLSearchParams(location.search);
    var active={};
    params.forEach(function(v,k){ if(k.indexOf('filter.')===0) active[k+SEP+v]=true; });
    var activeCount=Object.keys(active).length;
    var curSort=params.get('sort_by')||'';

    var SORTS=[
      {v:'created-descending',label:'Nouveautés'},
      {v:'best-selling',label:'Meilleures ventes'},
      {v:'price-ascending',label:'Prix croissant'},
      {v:'price-descending',label:'Prix décroissant'}
    ];
    var curSortLabel=''; SORTS.forEach(function(s){ if(s.v===curSort) curSortLabel=s.label; });

    function metaFor(name,value){
      for(var i=0;i<groups.length;i++){ for(var j=0;j<groups[i].values.length;j++){ var vv=groups[i].values[j]; if(vv.name===name && vv.value===value) return {group:groups[i].label, disp:vv.disp}; } }
      return {group:'', disp:value};
    }

    function go(p){ p.delete('page'); var qs=p.toString(); location.href=location.pathname+(qs?('?'+qs):''); }
    function applySelection(sel){
      var p=new URLSearchParams();
      params.forEach(function(v,k){ if(k.indexOf('filter.')!==0 && k!=='page') p.append(k,v); });
      Object.keys(sel).forEach(function(key){ var i=key.indexOf(SEP); p.append(key.slice(0,i), key.slice(i+1)); });
      go(p);
    }
    function sortTo(v){ var p=new URLSearchParams(location.search); if(v) p.set('sort_by',v); else p.delete('sort_by'); go(p); }
    function removeKey(key){ var i=key.indexOf(SEP), nm=key.slice(0,i), val=key.slice(i+1); var p=new URLSearchParams(); params.forEach(function(v,k){ if(!(k===nm && v===val)) p.append(k,v); }); go(p); }
    function clearAll(){ var p=new URLSearchParams(); params.forEach(function(v,k){ if(k.indexOf('filter.')!==0) p.append(k,v); }); go(p); }

    var count=(typeof window.TAMA_COLL_COUNT==='number')?window.TAMA_COLL_COUNT:null;

    /* --- construction --- */
    var el=document.createElement('div'); el.className='tama-cf';

    var bar=document.createElement('div'); bar.className='tama-cf__bar';
    var btnF=document.createElement('button'); btnF.type='button'; btnF.className='tama-cf__btn'; btnF.setAttribute('aria-expanded','false');
    btnF.innerHTML='<svg viewBox="0 0 24 24"><path d="M3 5h18M6 12h12M10 19h4"/></svg><span>Filtrer</span>';
    if(activeCount){ var n=document.createElement('i'); n.className='tama-cf__n'; n.textContent=activeCount; btnF.appendChild(n); }
    var btnS=document.createElement('button'); btnS.type='button'; btnS.className='tama-cf__btn'; btnS.setAttribute('aria-expanded','false');
    btnS.innerHTML='<svg viewBox="0 0 24 24"><path d="M8 4v16M8 4l-3 3M8 4l3 3M16 20V4M16 20l-3-3M16 20l3-3"/></svg><span>'+(curSortLabel||'Trier')+'</span>';
    var cnt=document.createElement('div'); cnt.className='tama-cf__count'; cnt.textContent=(count!=null)?(count+(count>1?' pièces':' pièce')):'';
    if(groups.length) bar.appendChild(btnF);
    bar.appendChild(btnS);
    /* 1 / 2 pieces par ligne (mobile) */
    var colsBox=document.createElement('div'); colsBox.className='tama-cf__cols'; colsBox.setAttribute('role','group'); colsBox.setAttribute('aria-label','Affichage');
    function mkCol(n,svg,label){ var b=document.createElement('button'); b.type='button'; b.className='tama-cf__col'+(cols===n?' is-on':''); b.setAttribute('aria-label',label); b.title=label; b.setAttribute('aria-pressed',cols===n?'true':'false'); b.innerHTML=svg; b.addEventListener('click',function(e){ e.stopPropagation(); setCols(n); }); return b; }
    var c1=mkCol(1,'<svg viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2"/></svg>','Une pièce par ligne');
    var c2=mkCol(2,'<svg viewBox="0 0 24 24"><rect x="3" y="3" width="8" height="18" rx="2"/><rect x="13" y="3" width="8" height="18" rx="2"/></svg>','Deux pièces par ligne');
    function setCols(n){ cols=n; body.classList.toggle('tama-cols-1',n===1); try{ localStorage.setItem(COLS_KEY,String(n)); }catch(e){}
      [[c1,1],[c2,2]].forEach(function(p){ var on=p[1]===n; p[0].classList.toggle('is-on',on); p[0].setAttribute('aria-pressed',on?'true':'false'); }); }
    colsBox.appendChild(c1); colsBox.appendChild(c2);
    bar.appendChild(colsBox); bar.appendChild(cnt);

    var chips=document.createElement('div'); chips.className='tama-cf__chips';
    Object.keys(active).forEach(function(key){ var i=key.indexOf(SEP); var meta=metaFor(key.slice(0,i),key.slice(i+1)); var c=document.createElement('button'); c.type='button'; c.className='tama-cf__chip'; var sp=document.createElement('span'); sp.textContent=(meta.group?meta.group+' · ':'')+meta.disp; var x=document.createElement('b'); x.textContent='×'; c.appendChild(sp); c.appendChild(x); c.addEventListener('click',function(){removeKey(key);}); chips.appendChild(c); });
    if(activeCount){ var clr=document.createElement('button'); clr.type='button'; clr.className='tama-cf__clear'; clr.textContent='Tout effacer'; clr.addEventListener('click',clearAll); chips.appendChild(clr); }
    if(!activeCount) chips.hidden=true;

    var panel=document.createElement('div'); panel.className='tama-cf__panel'; panel.hidden=true;
    var phead=document.createElement('div'); phead.className='tama-cf__phead';
    var pht=document.createElement('b'); pht.textContent='Filtrer';
    var px=document.createElement('button'); px.type='button'; px.className='tama-cf__x'; px.setAttribute('aria-label','Fermer'); px.innerHTML='<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    phead.appendChild(pht); phead.appendChild(px); panel.appendChild(phead);
    var sel=Object.assign({},active);
    groups.forEach(function(g){
      var gd=document.createElement('div'); gd.className='tama-cf__group';
      var h=document.createElement('div'); h.className='tama-cf__grouph'; h.textContent=g.label; gd.appendChild(h);
      var pl=document.createElement('div'); pl.className='tama-cf__pills';
      g.values.forEach(function(v){
        var key=v.name+SEP+v.value;
        var b=document.createElement('button'); b.type='button'; b.className='tama-cf__pill'+(sel[key]?' is-on':'');
        var sp=document.createElement('span'); sp.textContent=v.disp; b.appendChild(sp);
        if(v.count){ var ic=document.createElement('i'); ic.textContent=v.count; b.appendChild(ic); }
        b.addEventListener('click',function(){ if(sel[key]){delete sel[key]; b.classList.remove('is-on');} else {sel[key]=true; b.classList.add('is-on');} });
        pl.appendChild(b);
      });
      gd.appendChild(pl); panel.appendChild(gd);
    });
    var foot=document.createElement('div'); foot.className='tama-cf__foot';
    var fClear=document.createElement('button'); fClear.type='button'; fClear.className='tama-cf__ghost'; fClear.textContent='Tout effacer';
    fClear.addEventListener('click',function(){ sel={}; panel.querySelectorAll('.tama-cf__pill').forEach(function(p){p.classList.remove('is-on');}); });
    var fApply=document.createElement('button'); fApply.type='button'; fApply.className='tama-cf__apply'; fApply.textContent='Voir les résultats';
    fApply.addEventListener('click',function(){ applySelection(sel); });
    foot.appendChild(fClear); foot.appendChild(fApply); panel.appendChild(foot);

    var menu=document.createElement('div'); menu.className='tama-cf__menu'; menu.hidden=true;
    SORTS.forEach(function(s){ var mi=document.createElement('button'); mi.type='button'; mi.className='tama-cf__mitem'+(s.v===curSort?' is-on':''); mi.textContent=s.label; mi.addEventListener('click',function(){ sortTo(s.v); }); menu.appendChild(mi); });

    var bd=document.createElement('div'); bd.className='tama-cf__backdrop';
    el.appendChild(bd); el.appendChild(bar); el.appendChild(chips); el.appendChild(panel); el.appendChild(menu);

    function closeAll(){ panel.hidden=true; menu.hidden=true; bd.classList.remove('is-shown'); btnF.setAttribute('aria-expanded','false'); btnS.setAttribute('aria-expanded','false'); btnF.classList.remove('is-open'); btnS.classList.remove('is-open'); }
    btnF.addEventListener('click',function(e){ e.stopPropagation(); var wasOpen=!panel.hidden; closeAll(); if(!wasOpen){ panel.hidden=false; bd.classList.add('is-shown'); btnF.setAttribute('aria-expanded','true'); btnF.classList.add('is-open'); } });
    btnS.addEventListener('click',function(e){ e.stopPropagation(); var wasOpen=!menu.hidden; closeAll(); if(!wasOpen){ menu.hidden=false; bd.classList.add('is-shown'); btnS.setAttribute('aria-expanded','true'); btnS.classList.add('is-open'); } });
    px.addEventListener('click',function(e){ e.stopPropagation(); closeAll(); });
    bd.addEventListener('click',function(e){ e.stopPropagation(); closeAll(); });
    document.addEventListener('click',function(e){ if(!el.contains(e.target)) closeAll(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });

    /* cale la barre sticky juste sous le header (s'adapte mobile/desktop) */
    var hdr=document.querySelector('#shopify-section-header')||document.querySelector('.header-sticky')||document.querySelector('header.site-header');
    var ht=hdr?Math.round(hdr.getBoundingClientRect().height):0;
    if(ht>20 && ht<280) el.style.top=ht+'px';

    productsCol.parentNode.insertBefore(el, productsCol);
    if(quarter) quarter.style.display='none';
  });
})();
